import { AcUnit, Percent, PublishedWithChanges } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { MyAssortmentTFunction, useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { PriceControlAction } from '@retail/price-control/types';

interface Props {
  action: PriceControlAction;
}

export const EventAction = ({ action }: Props) => {
  const t = useMyAssortmentTFunction();
  const actionValues = getActionIcon(action, t);
  return (
    <Stack flexDirection="row" gap={1} alignItems="flex-start">
      {actionValues.icon}
      <Stack flexDirection="column" alignItems="flex-start" textAlign="start">
        <Typography variant="subtitle2">{actionValues.title}</Typography>
        <Typography variant="body3">{actionValues.desc}</Typography>
      </Stack>
    </Stack>
  );
};

export const getActionIcon = (action: PriceControlAction, t: MyAssortmentTFunction) => {
  switch (action) {
    case 'DO_NOTHING':
      return {
        icon: <PublishedWithChanges fontSize="small" />,
        title: t('myAssortment.priceControl.useNewPrice.title'),
        desc: t('myAssortment.priceControl.useNewPrice.description'),
      };
    case 'KEEP_OLD_COVERAGE':
      return {
        icon: <Percent fontSize="small" />,
        title: t('myAssortment.priceControl.keepCoverageeAndDg.title'),
        desc: t('myAssortment.priceControl.keepCoverageeAndDg.description'),
      };
    case 'KEEP_OLD_PRICE':
      return {
        icon: (
          <Typography variant="h4" pr={0.5}>
            =
          </Typography>
        ),
        title: t('myAssortment.priceControl.keepOldSalesPrice.title'),
        desc: t('myAssortment.priceControl.keepOldSalesPrice.description'),
      };
    case 'FREEZE_OLD_PRICE':
      return {
        icon: <AcUnit fontSize="small" />,
        title: t('myAssortment.priceControl.freezeOldSalesPrice.title'),
        desc: t('myAssortment.priceControl.freezeOldSalesPrice.description'),
      };
    case 'SPLIT_DIFFERENCE':
      return {
        icon: (
          <Typography variant="h5" pr={0.5}>
            ½
          </Typography>
        ),
        title: t('myAssortment.priceControl.halfPassThrough.title'),
        desc: t('myAssortment.priceControl.halfPassThrough.description'),
      };

    default:
      return { icon: null, title: '', desc: '' };
  }
};
